import { render, staticRenderFns } from "./LoginWithToken.vue?vue&type=template&id=484d78ca&scoped=true&"
import script from "./LoginWithToken.vue?vue&type=script&lang=js&"
export * from "./LoginWithToken.vue?vue&type=script&lang=js&"
import style0 from "./LoginWithToken.vue?vue&type=style&index=0&id=484d78ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484d78ca",
  null
  
)

component.options.__file = "LoginWithToken.vue"
export default component.exports